import * as React from 'react';
import { useDataLoader } from 'react-remote-data-hooks';
import api from '../../../api';
import { FilterValue, User } from '../../api';
import { IListFilterProps } from './props';
import noImage from '../../../assets/images/user-noimage.png';

interface IPriceFilterProps<T = any> extends IListFilterProps<T> {
  value?: FilterValue;
}

const PriceFilter: React.FunctionComponent<IPriceFilterProps> = (props) => {
  const startRef = React.useRef<HTMLInputElement>(null);
  const endRef = React.useRef<HTMLInputElement>(null);

  const [startPrice, setStartPrice] = React.useState(0);
  const [endPrice, setEndPrice] = React.useState(0);

  const onClose = () => {
    setStartPrice(0);
    setEndPrice(0);
    props.onClose?.();
  };

  React.useEffect(() => {
    setStartPrice(props.value?.value?.startPrice);
    setEndPrice(props.value?.value?.endPrice);
    // setSelected(props.value || []);
  }, [props.value]);

  const onApply = () => {
    // setStartPrice(0);
    // setEndPrice(0);
    if (startRef?.current) {
      startRef.current.value = '';
    }
    if (endRef?.current) {
      endRef.current.value = '';
    }

    props.applyFilter?.({
      label: `${startPrice ? startPrice + ' - ' : ''}${endPrice}`,
      value: { startPrice, endPrice },
    });
  };

  return (
    <div className="custom-dropdown__menu custom-dropdown__menu--open border overflow-auto w-100  bg-white zIndex-1">
      <div className="d-flex align-items-center justify-content-between bg-primary px-3 py-2 text-white mb-3">
        <h6 className="m-0 font-xs font-weight-semibold">{props.label}</h6>
        <span
          className="cursor-pointer d-inline-block text-center rounded-circle sub-dropdown-back ml-3"
          onClick={onClose}
        >
          <i className="icon-close font-xxs"></i>
        </span>
      </div>
      <div className="custom-dropdown__search  d-flex mb-2 position-sticky top-0 zIndex-1">
        <div className="row m-0">
          <div className="col-12 p-0">
            <input
              type="number"
              min={0}
              className="form-control border mb-3 py-0 px-1 font-weight-semibold font-normal"
              placeholder="Enter Start Price"
              onChange={(e) => setStartPrice(Number(e.target.value))}
              ref={startRef}
            />
          </div>

          <div className="col-12 p-0">
            <input
              type="number"
              min={0}
              className="form-control border py-0 px-1 font-weight-semibold font-normal"
              placeholder="Enter End Price"
              onChange={(e) => setEndPrice(Number(e.target.value))}
              ref={endRef}
            />
          </div>
        </div>
      </div>
      <div className="px-3 text-right">
        <button
          type="button"
          className="btn btn-primary py-2 px-4 font-weight-semibold"
          onClick={onApply}
        >
          <span className="px-2">Apply</span>
        </button>
      </div>
    </div>
  );
};

export default PriceFilter;
